import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { adicionarEmpreendimento } from '~/Store/Prospecto/actions';
import { Button, Modal, Form } from 'react-bootstrap';
import { Formik, useFormikContext } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import _size from 'lodash/size';
import { FaSpinner } from 'react-icons/fa';
import history from '../../../../Config/history';
import { default as Selector } from 'react-select';
import { default as auth } from '../../../../Utils/AuthStorage';
import SelectGerenteCorretor from '../../../GerentesCorretores/SelectGerenteCorretor';
import { EMPREENDIMENTO_LANCAMENTO, PROSPECTO_STATUS_ENUM } from '~/constant';
import * as helpers from '~/Utils/Helpers';
import { verificarSegundoProponente } from '~/Services/Service';

const ModalProspectoEmpreendimento = ({
  location,
  gerentesCorretores,
  empreendimentos,
  prospecto,
  salvandoEmpreendimento,
  erroAdicionarEmpreendimento,
  adicionarEmpreendimento,
}) => {
  let params = new URLSearchParams(location.search);
  const obterCorretorGerenteHerdado = () => {
    if (
      !prospecto ||
      !prospecto.prospecto_empreendimento ||
      prospecto.prospecto_empreendimento.length === 0
    ) {
      return null;
    }
    const vinculoAtivo = prospecto.prospecto_empreendimento.find(
      v =>
        v &&
        v.codigo_corretor > 0 &&
        v.codigo_gerente > 0 &&
        v.codigo_status !== PROSPECTO_STATUS_ENUM.descartado &&
        !v.respeitar_corretor_escolhido
    );
    if (!vinculoAtivo) return null;
    const nomeCorretor =
      vinculoAtivo.corretor && vinculoAtivo.corretor.nome
        ? vinculoAtivo.corretor.nome
        : vinculoAtivo.nome_corretor || '';
    const nomeGerente =
      vinculoAtivo.gerente && vinculoAtivo.gerente.nome
        ? vinculoAtivo.gerente.nome
        : '';
    return {
      codigo_corretor: vinculoAtivo.codigo_corretor,
      codigo_gerente: vinculoAtivo.codigo_gerente,
      nome_corretor: nomeCorretor,
      nome_gerente: nomeGerente,
    };
  };
  const corretorHerdado = obterCorretorGerenteHerdado();
  const podeAlterarVinculoHerdado = auth.isADM() || auth.isCAV();
  const travarPorHeranca = !!corretorHerdado && !podeAlterarVinculoHerdado;
  let initialValues = {
    ...prospecto,
    codigo_familia: '',
    codigo_corretor: '',
    codigo_gerente: '',
  };
  const verificarSegundoProponenteEAtualizar = async (
    codigoFamilia,
    cpf,
    setFieldValue
  ) => {
    if (!isMountedRef.current) return;
    const cpfFormatado =
      cpf && cpf.replace(/\D/g, '').length === 11
        ? helpers.format.cpf(cpf)
        : '';
    if (!cpfFormatado || cpfFormatado.length !== 14) {
      if (!isMountedRef.current) return;
      setSegundoProponenteInfo(null);
      setDirecionarParaCorretorOriginal(false);
      return;
    }
    try {
      const segundoProponente = await verificarSegundoProponente({
        codigo_familia: codigoFamilia || 0,
        cpf: cpfFormatado,
      });
      if (!isMountedRef.current) return;
      if (segundoProponente && segundoProponente.codigo_corretor != 0) {
        setSegundoProponenteInfo(segundoProponente);
        const ultima = segundoProponente.ultima_movimentacao
          ? new Date(segundoProponente.ultima_movimentacao)
          : null;
        const diasSemMovimento = ultima
          ? Math.floor((Date.now() - ultima.getTime()) / 86400000)
          : Infinity;
        const deveDirecionar =
          diasSemMovimento <= DIAS_VERIFICACAO_SEGUNDO_PROPONENTE;
        setDirecionarParaCorretorOriginal(deveDirecionar);
        if (deveDirecionar) {
          setFieldValue('codigo_corretor', segundoProponente.codigo_corretor);
          const infoCorretor =
            gerentesCorretores.corretoresById[
              segundoProponente.codigo_corretor
            ];
          if (infoCorretor && infoCorretor.CodigoGerente) {
            setFieldValue('codigo_gerente', infoCorretor.CodigoGerente);
          }
        }
      } else {
        setSegundoProponenteInfo(null);
        setDirecionarParaCorretorOriginal(false);
      }
    } catch (err) {
      if (!isMountedRef.current) return;
      setSegundoProponenteInfo(null);
      setDirecionarParaCorretorOriginal(false);
    }
  };

  const SelectComponent = () => {
    const { setFieldValue, values } = useFormikContext();
    useEffect(() => {
      const empreendimento = EMPREENDIMENTO_LANCAMENTO
        ? optionsEmpreendimento.find(
            option => option.value === EMPREENDIMENTO_LANCAMENTO
          )
        : null;
      if (!empreendimento) {
        setIsDisabledLancamento(false);
      }

      if (empreendimento && !values.codigo_familia) {
        setFieldValue('codigo_familia', empreendimento && empreendimento.value);
      }
      if (
        EMPREENDIMENTO_LANCAMENTO &&
        empreendimento.value === EMPREENDIMENTO_LANCAMENTO &&
        !auth.isCorretor()
      ) {
        setFieldValue('codigo_corretor', 1078);
        setFieldValue('codigo_gerente', 1077);
      }
      if (
        EMPREENDIMENTO_LANCAMENTO &&
        empreendimento.value === EMPREENDIMENTO_LANCAMENTO &&
        !isAtendenteLancamento &&
        !auth.isCorretor()
      ) {
        setIsDisabledLancamento(true);
      } else {
        setIsDisabledLancamento(false);
      }
    }, []);
    return (
      <>
        {' '}
        <Selector
          value={
            values.codigo_familia
              ? optionsEmpreendimento.find(
                  option => option.value === values.codigo_familia
                )
              : null
          }
          noOptionsMessage={() => 'Nenhum empreendimento encontrado'}
          placeholder="Pesquisar empreendimentos..."
          options={optionsEmpreendimento}
          onChange={async option => {
            setFieldValue('codigo_familia', option.value);

            await verificarSegundoProponenteEAtualizar(
              option.value,
              prospecto.cpf,
              setFieldValue
            );

            if (
              EMPREENDIMENTO_LANCAMENTO &&
              option.value === EMPREENDIMENTO_LANCAMENTO &&
              !isAtendenteLancamento &&
              !auth.isCorretor()
            ) {
              setFieldValue('codigo_corretor', 1078);
              setFieldValue('codigo_gerente', 1077);
              setIsDisabledLancamento(true);
            } else {
              setIsDisabledLancamento(false);
            }
          }}
          disabled={salvandoEmpreendimento}
        />
      </>
    );
  };

  if (corretorHerdado) {
    initialValues.codigo_corretor = corretorHerdado.codigo_corretor;
    initialValues.codigo_gerente = corretorHerdado.codigo_gerente;
  } else if (auth.isCorretor()) {
    const usuario = auth.getUser();
    const corretorLogado =
      gerentesCorretores.corretoresById &&
      gerentesCorretores.corretoresById[usuario.usuario];
    initialValues.codigo_corretor = usuario.usuario;
    initialValues.codigo_gerente =
      (corretorLogado &&
        (corretorLogado.codigo_gerente || corretorLogado.CodigoGerente)) ||
      usuario.gerente ||
      '';
  } else if (auth.isGerente()) {
    initialValues.codigo_gerente = auth.getUser().usuario;
  }

  const validationSchema = Yup.object().shape({
    codigo_familia: Yup.number().required('Selecione um empreendimento'),
    codigo_gerente: Yup.string().required('Selecione um gerente'),
    codigo_corretor: Yup.string().required('Selecione um corretor'),
  });

  const [isDisabledLancamento, setIsDisabledLancamento] = useState(false);
  const isAtendenteLancamento = auth.isAtendenteLancamento();
  const [segundoProponenteInfo, setSegundoProponenteInfo] = useState(null);
  const [
    direcionarParaCorretorOriginal,
    setDirecionarParaCorretorOriginal,
  ] = useState(false);
  const DIAS_VERIFICACAO_SEGUNDO_PROPONENTE = 30;
  const isMountedRef = useRef(true);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const optionsEmpreendimento = empreendimentos.sort.map(item => ({
    value: item.codigo,
    label: item.descricao,
  }));

  // const optionsEmpreendimento = [
  //   {
  //     value: 11339,
  //     label: 'SETLIFE ESSENCE (UBERABA)',
  //   },
  // ];

  const buildValueEmpreendimento = empreendimento => {
    return empreendimento
      ? {
          value: parseInt(empreendimentos.byId[empreendimento].codigo),
          label: empreendimentos.byId[empreendimento].descricao,
        }
      : { value: '', label: 'Selecione um empreendimento' };
  };

  const vincularEmpreendimento = values => {
    const payload = { ...values };
    if (segundoProponenteInfo && direcionarParaCorretorOriginal) {
      payload.codigo_corretor = segundoProponenteInfo.codigo_corretor;
      toast.warn(
        `Cadastro direcionado ao corretor original: ${segundoProponenteInfo.nome_corretor}`
      );
    }
    if (corretorHerdado && podeAlterarVinculoHerdado) {
      const corretorAlterado =
        Number(values.codigo_corretor) !==
        Number(corretorHerdado.codigo_corretor);
      const gerenteAlterado =
        Number(values.codigo_gerente) !==
        Number(corretorHerdado.codigo_gerente);
      if (corretorAlterado || gerenteAlterado) {
        payload.respeitar_corretor_escolhido = true;
      }
    }
    adicionarEmpreendimento(payload);
  };

  if (!params.get('vincular-empreendimento')) {
    return null;
  }

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={vincularEmpreendimento}
      validationSchema={validationSchema}
    >
      {({ setFieldValue, values, errors, submitCount, handleSubmit }) => {
        // const cadastroDuranteLancamento = values.codigo_familia === EMPREENDIMENTO_LANCAMENTO && auth.isADM();
        return (
          <Modal show={true} onHide={() => history.push({ search: '' })}>
            <Modal.Header closeButton>
              <Modal.Title>Vicular Empreendimento</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="prospecto.codigo_familia">
                  <Form.Label srOnly>Selecione um empreendimento</Form.Label>
                  <SelectComponent />
                  {segundoProponenteInfo && direcionarParaCorretorOriginal && (
                    <div className="alert alert-warning mt-2">
                      CPF já existe como segundo proponente em lead recente. Ao
                      salvar, o cadastro será direcionado para o corretor
                      original {segundoProponenteInfo.nome_corretor}.
                    </div>
                  )}
                </Form.Group>

                {values.codigo_familia && (
                  <>
                    {corretorHerdado && (
                      <div className="alert alert-info mt-2 mb-2">
                        Este lead já é atendido pelo corretor{' '}
                        <strong>
                          {corretorHerdado.nome_corretor || 'já vinculado'}
                        </strong>
                        {corretorHerdado.nome_gerente
                          ? ' (gerente '
                          : ''}
                        {corretorHerdado.nome_gerente && (
                          <strong>{corretorHerdado.nome_gerente}</strong>
                        )}
                        {corretorHerdado.nome_gerente ? ')' : ''} em outro
                        interesse. Os campos foram preenchidos automaticamente
                        {podeAlterarVinculoHerdado
                          ? '. Você pode alterá-los manualmente, se necessário.'
                          : ' e travados para garantir continuidade do atendimento.'}
                      </div>
                    )}
                    <SelectGerenteCorretor
                      // disabledCorretor={cadastroDuranteLancamento}
                      // disabledGerente={cadastroDuranteLancamento}
                      gerente={values.codigo_gerente}
                      corretor={values.codigo_corretor}
                      onChangeCorretor={corretor =>
                        setFieldValue('codigo_corretor', corretor)
                      }
                      onChangeGerente={gerente =>
                        setFieldValue('codigo_gerente', gerente)
                      }
                      administradoresLancamento={isDisabledLancamento}
                      disabledGerente={travarPorHeranca}
                      disabledCorretor={travarPorHeranca}
                      mostrarParaCorretor={auth.isCAV()}
                    />
                  </>
                )}
                {submitCount > 0 && _size(errors) > 0 && (
                  <div className="FormDadosPessoais__error text-danger">
                    Preenchas os campos corretamente antes de salvar
                  </div>
                )}
                {erroAdicionarEmpreendimento && (
                  <div className="FormDadosPessoais__error text-danger">
                    {erroAdicionarEmpreendimento}
                  </div>
                )}
                <div className="d-flex d-sm-block text-right justify-content-between">
                  <Button
                    variant="link"
                    className="text-uppercase px-4 d-block d-sm-inline-block"
                    onClick={() => history.push({ search: '' })}
                    disabled={salvandoEmpreendimento}
                  >
                    Cancelar
                  </Button>
                  <Button
                    variant="primary"
                    type="button"
                    onClick={handleSubmit}
                    className="text-uppercase px-4 d-block d-sm-inline-block"
                    disabled={salvandoEmpreendimento}
                  >
                    {salvandoEmpreendimento ? (
                      <span>
                        <FaSpinner /> Salvando...
                      </span>
                    ) : (
                      'Salvar'
                    )}
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
        );
      }}
    </Formik>
  );
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      adicionarEmpreendimento,
    },
    dispatch
  );

const mapStateToProps = state => ({
  salvandoEmpreendimento: state.prospecto.adicionandoEmpreendimento,
  erroAdicionarEmpreendimento: state.prospecto.erroAdicionarEmpreendimento,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ModalProspectoEmpreendimento)
);
